<template>
  <v-dialog v-model="dialog" content-class="detail-dialog" @click:outside="close" @keydown.esc="close">
    <v-toolbar>
      <v-toolbar-title>
        <v-icon v-if="fields[8].value === 'B'">upload</v-icon>
        <v-icon v-else>edit</v-icon>
        {{ fields[1].value || 'New transaction' }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="close"><v-icon>clear</v-icon></v-btn>
    </v-toolbar>
    <v-card flat :loading="loading" class="detail-dialog-card">
      <v-card-text>
        <v-form v-if="loaded" v-model="valid">
          <v-container class="pt-2">
            <EditForm class="transaction-form" :items="fields" @data-changed="onDataChanged" ref="editForm" creating />
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-container fluid>
          <v-row>
            <v-col offset="6" cols="3">
              <v-btn block :disabled="!changed || !valid" @click="save">
                <v-icon left>done</v-icon> Save
              </v-btn>
            </v-col>
            <v-col cols="3">
              <v-btn block :disabled="!changed" @click="reset">
                Reset
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { namespace, Getter } from 'vuex-class'
import EditForm from '@/components/public/EditForm'

const SubModule = namespace('transaction')

@Component({
  components: {
    EditForm
  }
})
export default class TransactionDetail extends Vue {
  dialog = false
  loaded = false
  loading = false
  accounts = []
  banks = []
  accountTypes = []
  itemId = null
  changed = false
  valid = false

  @Getter entity
  @SubModule.Getter fields
  @SubModule.Getter category

  @SubModule.Action setFieldItems
  @SubModule.Action getGstRegistered
  @SubModule.Action setGstIncluded
  @SubModule.Action enableGstIncluded
  @SubModule.Action updateFromAPI

  onDataChanged (item) {
    this.changed = true
  }

  open (dw) {
    this.dialog = true
    this.itemId = null
    this.loaded = false
    this.initNew()
    this.$nextTick(() => {
      this.loaded = true
      this.$nextTick(() => {
        this.$refs.editForm.setFieldValue('gst_included', 'value', false)
        this.$refs.editForm.setFieldValue('trans_type', 'value', dw)
      })
    })
  }

  initNew () {
    this.fields.map(item => {
      item.value = ''
      item.disabled = false
    })
  }

  close () {
    this.dialog = false
    this.$emit('close-detail')
  }

  save () {
    this.loading = true
    const data = this.$refs.editForm.save()
    data.items.push({
      name: 'entity',
      value: this.entity.id
    })
    if (data.items.filter(item => item.name === 'trans_type').length === 0) {
      data.items.push({
        name: 'trans_type',
        value: this.fields[6].value
      })
    }

    this.setFieldItems(data)
      .then(resp => {
        this.changed = false
        this.$emit('update-detail')
        this.$emit('show-message', { message: 'Transaction saved!' })
        this.close()
      })
      .catch(err => {
        const resp = err.response
        this.$emit('show-message', {
          message: 'Failed to save',
          error: resp.data.detail || resp.statusText
        })
      })
      .finally(() => {
        this.loading = false
      })
  }

  reset () {
    this.$refs.editForm.cancel()
    this.changed = false
  }

  load (pk) {
    this.loaded = false
    this.itemId = pk
    this.updateFromAPI(pk)
      .then(resp => {
        const disabled = this.fields[8].value === 'B'
        this.fields[4].disabled = this.fields[6].disabled = this.fields[7].disabled = disabled
        this.loaded = true
        this.dialog = true
      })
      .catch(err => {
        const resp = err.response
        this.$emit('show-message', {
          message: 'Failed to get detail',
          error: resp.data.detail || resp.statusText
        })
      })
  }
}
</script>

<style lang="scss">
.active-account {
  border-left: 2px solid blue;
}
.transaction-form .v-input--checkbox {
  margin-left: 16px;
}
.detail-dialog {
  position: fixed;
  margin: 0;
  width: auto;
  top: 0; left: 50%; bottom: 0; right: 0;
  max-height: 100% !important;
  @media screen and (max-width: 960px) {
    left: 30%;
  }
  @media screen and (max-width: 600px) {
    left: 10%;
  }
}
.detail-dialog-card {
  border-radius: 0 !important;
  position: absolute;
  top: 64px; bottom: 0;
  left: 0; right: 0;
  @media screen and (max-width: 960px) {
    top: 56px;
  }
}
</style>
